module.exports = __webpack_public_path__ + "img/gylIcon.aaef6d39.svg";